import React, { useCallback, useState } from 'react'
import useConfigureAndSendTag from '../../analytics/useConfigureAndSendTag'
import { useDispatch, useSelector } from 'react-redux'
import { setStepFromSuggestion } from '../../../store/itinerary/itinerary.actions'
import { setStepIdx } from '../../../store/itinerary/itinerarySlice'
import { selectHomeWorkOrFakeFavorites } from '../../../store/suggest/suggest.selectors'
import { removeHtmlEmSpanAndITags, removeHtmlEmTags } from '../../../utils/string'
import T from '../../i18n/T'
import { withFrenchSite } from '../../i18n/i18nSite'
import { selectIsDepartureFilled, selectStepsLength } from '../../itinerary/steps/steps.selectors'
import SuggestContentList from '../../suggest/SuggestContentList'
import useIncentiveClick from '../../suggest/useIncentiveClick'
import { useAction } from '../../utils/react-redux'
import s from './FavoritesPush.less'
import useFavoritePushTagBuilder from './useFavoriteClickHandler'

const FavoritesPushHpIti = () => {
  const homeWorkFavorites = useSelector(selectHomeWorkOrFakeFavorites)
  const [selectedId, setSelectedId] = useState(null)

  const updateSelectedId = idx => {
    setSelectedId(idx)
  }

  const isDepartureFilled = useSelector(selectIsDepartureFilled)
  const stepLength = useSelector(selectStepsLength)

  const execSetStepFromSuggestion = useAction(setStepFromSuggestion)
  const dispatch = useDispatch()
  const configureAndSendTag = useConfigureAndSendTag()

  const idx = isDepartureFilled ? stepLength - 1 : 0

  const { favoritePushTabBuilder } = useFavoritePushTagBuilder()

  const onClick = useCallback(
    suggest => {
      configureAndSendTag(favoritePushTabBuilder(suggest))

      const { labels = [], address } = suggest
      const label = removeHtmlEmTags(address || labels.join(' '))
      const split_label = labels.map(removeHtmlEmSpanAndITags)

      dispatch(setStepIdx(idx))
      execSetStepFromSuggestion({
        suggest: {
          ...suggest,
          label,
          split_label
        }
      })
    },
    [favoritePushTabBuilder, idx]
  )

  const { onIncentiveClick } = useIncentiveClick({ onClick, incentiveTagClickBuilder: favoritePushTabBuilder })

  return (
    <div className={s.FavoritesPushHpIti}>
      <div className={s.FavoritesPushTitle}>
        <span>
          <T id={isDepartureFilled ? 'suggest.favorites.itinerary.arrival' : 'suggest.favorites.itinerary.departure'} />
        </span>
      </div>
      <SuggestContentList
        suggestions={homeWorkFavorites}
        onClick={onIncentiveClick}
        selectedId={selectedId}
        updateSelectedId={updateSelectedId}
      />
    </div>
  )
}
export default withFrenchSite(FavoritesPushHpIti)
